import "./customers.scss";
import Vue from 'vue/dist/vue.esm'
import CustomersApp from './customers-app.vue'
import ActionCableVue from 'actioncable-vue';

const websocket_protocol = `ws${window.location.protocol === "https:" ? "s" : ""}:`;
Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'info',
  connectionUrl: `${websocket_protocol}//${window.location.host}/cable`,
  connectImmediately: true
});

document.addEventListener("DOMContentLoaded", () => {
  Array.from(document.getElementsByClassName("customers"))
       .forEach(element => {
         const customers = JSON.parse(element.dataset.customers);
         new Vue({
                   data: {
                     customers: customers,
                   },
                   template: "<CustomersApp :original_customers='customers' />",
                   components: {
                     CustomersApp,
                   }
                 }).$mount(element);
       });
});
